import React from "react";
import { Link } from "react-router-dom";
import { API } from "@/lib/api";

const WA_NUMBER = "6282114294101";

export default function PromoSection() {
  const [items, setItems] = React.useState([]);
  const [lightbox, setLightbox] = React.useState(null); // poster object or null

  React.useEffect(() => {
    fetch(`${API}/posters`, { credentials: "omit" })
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => setItems(Array.isArray(data) ? data : []))
      .catch(() => setItems([]));
  }, []);

  // Close lightbox on ESC
  React.useEffect(() => {
    if (!lightbox) return;
    const onKey = (e) => {
      if (e.key === "Escape") setLightbox(null);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [lightbox]);

  // Section auto-hidden if no published posters
  if (!items || items.length === 0) return null;

  const waUrl = (judul) =>
    `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
      `Assalamu'alaikum, saya tertarik dengan ${judul}`
    )}`;

  return (
    <section
      className="py-24 lg:py-32 bg-muted/30"
      data-testid="promo-section"
    >
      <div className="container-x">
        <header className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-6">
          <div className="max-w-xl">
            <div className="flex items-center gap-4 mb-4">
              <span className="h-px w-10 bg-accent" />
              <p className="overline">Promo &amp; Penawaran</p>
            </div>
            <h2 className="font-serif text-4xl lg:text-5xl text-primary tracking-tight">
              Promo Terbaru
            </h2>
            <p className="mt-5 text-muted-foreground text-lg">
              Penawaran spesial paket umrah &amp; haji BATIK Tour &amp; Travel yang sedang berlangsung.
            </p>
          </div>
        </header>

        <div
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6"
          data-testid="promo-grid"
        >
          {items.map((p) => (
            <div
              key={p.id}
              className="group bg-card border border-border rounded-lg overflow-hidden flex flex-col hover:shadow-xl transition-shadow duration-300"
              data-testid={`promo-card-${p.id}`}
            >
              <button
                type="button"
                onClick={() => setLightbox(p)}
                className="block w-full overflow-hidden aspect-[3/4] bg-muted"
                aria-label={`Lihat ${p.judul}`}
                data-testid={`promo-image-btn-${p.id}`}
              >
                <img
                  src={`${API}/posters/${p.id}/gambar`}
                  alt={p.alt_text || p.judul}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </button>
              <div className="p-4 flex flex-col gap-3 flex-1">
                <h3 className="font-serif text-base md:text-lg text-primary leading-snug line-clamp-2">
                  {p.judul}
                </h3>
                {p.deskripsi && (
                  <p className="text-sm text-muted-foreground line-clamp-3">
                    {p.deskripsi}
                  </p>
                )}
                <a
                  href={waUrl(p.judul)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary mt-auto inline-flex items-center justify-center gap-2 text-sm"
                  data-testid={`promo-wa-${p.id}`}
                >
                  Tanya via WhatsApp
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>

      {lightbox && (
        <div
          className="fixed inset-0 z-[80] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 anim-fade-up"
          onClick={() => setLightbox(null)}
          data-testid="promo-lightbox"
        >
          <div
            className="relative max-w-3xl w-full max-h-[90vh] flex flex-col items-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={`${API}/posters/${lightbox.id}/gambar`}
              alt={lightbox.alt_text || lightbox.judul}
              className="max-h-[80vh] w-auto object-contain rounded-lg shadow-2xl"
            />
            <div className="mt-4 flex items-center justify-between w-full gap-3 flex-wrap">
              <p className="text-white font-serif text-lg">{lightbox.judul}</p>
              <div className="flex items-center gap-2">
                <a
                  href={waUrl(lightbox.judul)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary text-sm"
                  data-testid="promo-lightbox-wa"
                >
                  Tanya via WhatsApp
                </a>
                <button
                  type="button"
                  onClick={() => setLightbox(null)}
                  className="px-4 py-2 rounded-md bg-white/10 hover:bg-white/20 text-white text-sm"
                  data-testid="promo-lightbox-close"
                >
                  Tutup
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
